exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".required {\n    color: red;\n}\n\nh3 {\n    text-align: center;\n    margin-top: 0px;\n    margin-bottom: 30px;\n}\n\n.to-right {\n    text-align: right;\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.required {\n    color: red;\n    margin-right: 4px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/flexible-dropdown/flexible-dropdown.component.css
// module id = 826
// module chunks = 0